console.log("🔧 UpCart collection refresh-and-open handler active");

document.addEventListener("DOMContentLoaded", () => {
  const lockedButtons = new WeakSet();

  async function getCart() {
    try {
      const res = await fetch("/cart.js", {
        headers: { Accept: "application/json" },
        cache: "no-store",
      });

      if (!res.ok) throw new Error("Failed to fetch cart");
      return await res.json();
    } catch (err) {
      console.error("❌ Could not fetch cart:", err);
      return null;
    }
  }

  async function waitForCartChange(beforeCount, timeout = 5000, interval = 150) {
    const start = Date.now();

    while (Date.now() - start < timeout) {
      const cart = await getCart();

      if (cart && typeof cart.item_count === "number" && cart.item_count > beforeCount) {
        return cart;
      }

      await new Promise((resolve) => setTimeout(resolve, interval));
    }

    return null;
  }

  function refreshAndOpenUpCart() {
    try {
      if (typeof window.upcartRefreshCart === "function") {
        window.upcartRefreshCart();
        console.log("✅ UpCart refresh triggered");
      } else {
        console.warn("⚠️ upcartRefreshCart function not found");
      }

      setTimeout(() => {
        if (typeof window.upcartOpenCart === "function") {
          window.upcartOpenCart();
          console.log("✅ UpCart opened");
        } else {
          console.warn("⚠️ upcartOpenCart function not found");
        }
      }, 250);
    } catch (err) {
      console.error("❌ Error refreshing/opening UpCart:", err);
    }
  }

  document.body.addEventListener("click", async (e) => {
    const btn = e.target.closest(".productitem--action-trigger");
    if (!btn) return;

    if (lockedButtons.has(btn)) {
      e.preventDefault();
      return;
    }

    lockedButtons.add(btn);
    btn.setAttribute("aria-busy", "true");
    btn.classList.add("is-adding");

    const beforeCart = await getCart();
    const beforeCount = beforeCart ? beforeCart.item_count || 0 : 0;

    // Important:
    // Do NOT preventDefault()
    // Do NOT manually POST to /cart/add.js
    // Let the theme handle the single add

    const updatedCart = await waitForCartChange(beforeCount, 5000, 150);

    if (updatedCart) {
      console.log("✅ Cart updated:", updatedCart);
      refreshAndOpenUpCart();
    } else {
      console.warn("⚠️ Cart did not update in time");
    }

    setTimeout(() => {
      lockedButtons.delete(btn);
      btn.removeAttribute("aria-busy");
      btn.classList.remove("is-adding");
    }, 500);
  });
});

// product-shipping-origin.liquid content

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-shipping-origin]').forEach(function (widget) {
    const trigger = widget.querySelector('.acq-shipping-origin__trigger');
    const tooltip = widget.querySelector('.acq-shipping-origin__tooltip');

    if (!trigger || !tooltip) return;

    const openTooltip = () => {
      widget.classList.add('is-open');
      tooltip.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    };

    const closeTooltip = () => {
      widget.classList.remove('is-open');
      tooltip.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    };

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      const isOpen = widget.classList.contains('is-open');
      if (isOpen) {
        closeTooltip();
      } else {
        openTooltip();
      }
    });

    widget.addEventListener('mouseenter', openTooltip);
    widget.addEventListener('mouseleave', closeTooltip);

    document.addEventListener('click', function (e) {
      if (!widget.contains(e.target)) {
        closeTooltip();
      }
    });
  });
});